import React from "react";
import "./ImageBlock.css";

function ImageBlock() {
    return(
        <section className="image-block">
            <h1 className="image-block__title">Одежда из Америки и Европы</h1>
        </section>
    )
}

export default ImageBlock;
